import { scheduleDetailDataApi } from "../../../api/api";

const actions = {
    async scheduleDetailDataAction(context, params) {
        try {
            const result = await scheduleDetailDataApi(params);

            return new Promise((resolve, reject) => {
                if (result.status === 200) {
                    context.commit('scheduleDetailDataMutation', result.data);
                    resolve(result.data);
                }
                else reject(result.status);
            });

        } catch (error) {
            console.log(error);
        }
    },
};

export default actions;
